<ng-container *ngIf="videosDirecto.length > 0">
  <hr />
  <div class="contenedor-directo">
    <h6 class="directo">
      <!--  <h6 class="directo" [routerLink]="['/canal', 'Estado de Alarma LIVE' | kebabCase]"> -->
      <span>Directo</span><span>{{ constantesGlobales().siteName }}</span>
    </h6>
    <ng-container *ngFor="let item of videosDirecto; trackBy: trackItem">
      <h2 class="noticia-directo" [routerLink]="['/noticias', item?.idVideo, item?.tituloSeo | kebabCase]">{{ item?.tituloVideo }}</h2>
    </ng-container>
  </div>
  <hr />
</ng-container>
<div class="noticias">
  <ng-container *ngIf="!estructuraBySeccion">
    <app-estructura-defecto [videosDirecto]="videosDirecto" [publicidadCabecera]="publicidadCabecera" [publicidadTop]="publicidadTop" [publicidadBloques]="publicidad_bloques" [publicidadDivisoresMovil]="publicidad_divisores_movil" [showFecha]="showFecha" style="width: 100%"> </app-estructura-defecto>
  </ng-container>
  <ng-container *ngIf="estructuraBySeccion">
    <app-estructura-seccion [videosDirecto]="videosDirecto" [constantesGlobales]="constantesGlobales" [publicidadCabecera]="publicidadCabecera" [publicidadTop]="publicidadTop" [publicidadBloques]="publicidad_bloques" [publicidadDivisoresMovil]="publicidad_divisores_movil"> </app-estructura-seccion>
  </ng-container>
  <!--  <app-navbar-iframes *ngIf="showIframesComponent" id="frames-component"></app-navbar-iframes>-->
  <!--  <div id="taboola-below-home-thumbnails"></div>-->
</div>
